import React, { FC, useEffect, useState } from 'react';
import AdSense from 'react-adsense';
import {
  ADSENSE_CLIENT,
  ADSENSE_SLOT,
  isAdSenseEnabled,
  isHubAdPath,
  isToolsPath,
} from 'config/ads';

const shellStyle: any = {
  width: '100%',
  maxWidth: 728,
  marginTop: 24,
  marginBottom: 16,
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingTop: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 12,
  borderTop: '1px solid #ECECEC',
  boxSizing: 'border-box',
  // Cap so it stays a banner, not a huge block — still tall enough to fill
  maxHeight: 140,
  overflow: 'hidden',
};

const labelStyle: any = {
  fontSize: 11,
  lineHeight: '14px',
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: '#A3A3A3',
  marginBottom: 8,
  textAlign: 'center',
  fontFamily: 'system-ui, sans-serif',
};

const unitStyle: any = {
  display: 'block',
  width: '100%',
  minHeight: 90,
  maxHeight: 120,
  overflow: 'hidden',
};

/**
 * Compact hub banner (Test list / Part list only).
 * Must remain visible and fillable for revenue; capped to avoid large/full-screen layouts.
 */
const SubtleAd: FC = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!isAdSenseEnabled() || isToolsPath() || !isHubAdPath()) return;
    const timer = setTimeout(() => setReady(true), 600);
    return () => clearTimeout(timer);
  }, []);

  if (!isAdSenseEnabled() || isToolsPath() || !isHubAdPath() || !ready) {
    return null;
  }

  return (
    <div style={shellStyle} aria-label="Sponsored" data-l123-manual-ad="1">
      <div style={labelStyle}>Sponsored</div>
      <AdSense.Google
        client={ADSENSE_CLIENT}
        slot={ADSENSE_SLOT}
        style={unitStyle}
        format="horizontal"
        responsive="true"
      />
    </div>
  );
};

export default SubtleAd;
